export enum UnitOfMeasurement {
  Piece = '1',
  Gram = '2',
  Milliliter = '3'
}

const { Gram, Milliliter, Piece } = UnitOfMeasurement

const labelTextMapping = new Map([
  [Gram, 'Вес, г'],
  [Milliliter, 'Объём, мл'],
  [Piece, 'Количество, шт.']
])

export const UnitOfMeasurementUtils = {
  getLabelText: (x: UnitOfMeasurement): string => labelTextMapping.get(x)!
}
